import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button } from '@one-thd/sui-atomic-components';
import { Calculator } from "@one-thd/sui-icons";
import { QueryProvider } from '@thd-nucleus/data-sources';
import { QuickEstimateDrawer } from './QuickEstimateDrawer';

export const QuickEstimate = ({ materials }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const handleOpenDrawer = () => {
    setIsDrawerOpen(true);
  };

  const handleCloseDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <>
      <Button
        variant="secondary"
        startIcon={Calculator}
        data-testid="quick-estimate-button"
        onClick={handleOpenDrawer}
      >
       Quick Estimate
      </Button>
      <QueryProvider cacheKey="quick-estimate-drawer">
        <QuickEstimateDrawer
          open={isDrawerOpen}
          onClose={handleCloseDrawer}
          materials={materials}
        />
      </QueryProvider>
    </>
  );
};

QuickEstimate.displayName = 'QuickEstimate';

QuickEstimate.propTypes = {
  materials: PropTypes.arrayOf(PropTypes.shape({
    groupName: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.shape({
      itemId: PropTypes.string,
      intentId: PropTypes.string,
      quantity: PropTypes.number,
      intent: PropTypes.string
    }))
  }))
};

QuickEstimate.defaultProps = {
  materials: []
};
